




import Chart from "chart.js";
import formatCurrency from "../../helpers/formatCurrency";
import store from "../../store";
// @ts-ignore
Chart.defaults.global.defaultFontFamily = "'Manrope', 'sans-serif'";
// @ts-ignore
Chart.defaults.global.defaultFontColor = "#8693A0";
// @ts-ignore
Chart.elements.Rectangle.prototype.draw = function() {
  const ctx = this._chart.ctx;
  const vm = this._view;
  let left,
    right,
    top,
    bottom,
    signX,
    signY,
    borderSkipped,
    nextCorner,
    nextCornerId,
    x,
    y,
    width,
    height;
  let borderWidth = vm.borderWidth;
  // Set Radius Here
  // If radius is large enough to cause drawing errors a max radius is imposed
  const cornerRadius = 20;

  if (!vm.horizontal) {
    // bar
    left = vm.x - vm.width / 2;
    right = vm.x + vm.width / 2;
    top = vm.y;
    bottom = vm.base;
    signX = 1;
    signY = bottom > top ? 1 : -1;
    borderSkipped = vm.borderSkipped || "bottom";
  } else {
    // horizontal bar
    left = vm.base;
    right = vm.x;
    top = vm.y - vm.height / 2;
    bottom = vm.y + vm.height / 2;
    signX = right > left ? 1 : -1;
    signY = 1;
    borderSkipped = vm.borderSkipped || "left";
  }

  // Canvas doesn't allow us to stroke inside the width so we can
  // adjust the sizes to fit if we're setting a stroke on the line
  if (borderWidth) {
    // borderWidth shold be less than bar width and bar height.
    const barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
    borderWidth = borderWidth > barSize ? barSize : borderWidth;
    const halfStroke = borderWidth / 2;
    // Adjust borderWidth when bar top position is near vm.base(zero).
    const borderLeft =
      left + (borderSkipped !== "left" ? halfStroke * signX : 0);
    const borderRight =
      right + (borderSkipped !== "right" ? -halfStroke * signX : 0);
    const borderTop = top + (borderSkipped !== "top" ? halfStroke * signY : 0);
    const borderBottom =
      bottom + (borderSkipped !== "bottom" ? -halfStroke * signY : 0);
    // not become a vertical line?
    if (borderLeft !== borderRight) {
      top = borderTop;
      bottom = borderBottom;
    }
    // not become a horizontal line?
    if (borderTop !== borderBottom) {
      left = borderLeft;
      right = borderRight;
    }
  }

  ctx.beginPath();
  ctx.fillStyle = vm.backgroundColor;
  ctx.strokeStyle = vm.borderColor;
  ctx.lineWidth = borderWidth;

  // Corner points, from bottom-left to bottom-right clockwise
  // | 1 2 |
  // | 0 3 |
  const corners = [
    [left, bottom],
    [left, top],
    [right, top],
    [right, bottom]
  ];

  // Find first (starting) corner with fallback to 'bottom'
  const borders = ["bottom", "left", "top", "right"];
  let startCorner = borders.indexOf(borderSkipped, 0);
  if (startCorner === -1) {
    startCorner = 0;
  }

  function cornerAt(index) {
    return corners[(startCorner + index) % 4];
  }

  // Draw rectangle from 'startCorner'
  let corner = cornerAt(0);
  ctx.moveTo(corner[0], corner[1]);

  for (let i = 1; i < 4; i++) {
    corner = cornerAt(i);
    nextCornerId = i + 1;
    if (nextCornerId == 4) {
      nextCornerId = 0;
    }

    nextCorner = cornerAt(nextCornerId);

    width = 6;
    height = corners[0][1] - corners[1][1];
    x = corners[1][0] - 3;
    y = corners[1][1];

    let radius = cornerRadius;

    // Fix radius being too large
    if (radius > height / 2) {
      radius = height / 2;
    }
    if (radius > width / 2) {
      radius = width / 2;
    }

    let rounded = true;
    if (!this._chart.getDatasetMeta(0).hidden) {
      rounded = this._datasetIndex === 2 || this._datasetIndex === 1;
    }
    if (rounded) {
      ctx.moveTo(x + radius, y);
      ctx.lineTo(x + width - radius, y);
      ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
      ctx.lineTo(x + width, y + height - radius);
      ctx.quadraticCurveTo(
        x + width,
        y + height,
        x + width - radius,
        y + height
      );
      ctx.lineTo(x + radius, y + height);
      ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
      ctx.lineTo(x, y + radius);
      ctx.quadraticCurveTo(x, y, x + radius, y);
    } else {
      ctx.moveTo(x + radius, y);
      ctx.lineTo(x + width - radius, y);
      ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
      ctx.lineTo(x + width, y + height);
      // ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
      ctx.lineTo(x, y + height);
      // ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
      ctx.lineTo(x, y + radius);
      ctx.quadraticCurveTo(x, y, x + radius, y);
    }
  }

  ctx.fill();
  if (borderWidth) {
    ctx.stroke();
  }
};

const getRandomInt = function() {
  return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
};

export default {
  props: ["data", "labels", "store"],
  mounted() {
    const ctxBar = document.getElementById("myChart2");
    const data = {
      labels: this.labels,
      datasets: [
        {
          borderWidth: 1,
          borderColor: "#ffffff",
          barThickness: 1,
          backgroundColor: "#E1E3E5",
          data: this.data,
          label: "Sales"
        }
      ]
    };
    const options = {
      tooltips: {
        callbacks: {
          label: function(tooltipItem, data) {
            let label = data.datasets[tooltipItem.datasetIndex].label || "";

            if (label) {
              label += ": ";
            }
            label += `${formatCurrency(
              tooltipItem.yLabel.toFixed(2),
              store.state.store.primaryLocale +
                "-" +
                store.state.store.countryCode,
              store.state.store.primaryCurrencyCode
            )}`;

            return label;
          }
        }
      },
      height: 100,
      layout: {
        padding: {
          left: 15,
          right: 20,
          top: 20,
          bottom: 10
        }
      },
      elements: {
        point: {
          radius: 25,
          hitRadius: 10,
          hoverRadius: 10,
          pointStyle: "rectRounded"
        }
      },
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      scales: {
        yAxes: [
          {
            ticks: {
              display: false
            },
            gridLines: {
              drawBorder: false,
              borderDash: [3, 2],
              color: "#E7E9EC",
              zeroLineBorderDash: [3, 2],
              zeroLineColor: "#E7E9EC"
            },
            stacked: true
          }
        ],
        xAxes: [
          {
            ticks: {
              display: false
            },
            stacked: true,
            gridLines: {
              display: false
            }
          }
        ]
      }
    };
    // @ts-ignore
    const myBarChart = new Chart(ctxBar, {
      type: "bar",
      data: data,
      options: options
    });
  }
};
